import cameronPic from "@/public/images/artists/cameron.png";
import { Artist } from "@/types/types";

export const cameron = {
  id: "259",
  name: "Cameron",
  image: cameronPic,
  description: `Cameron's voice is warm and grounded, with a bold, confident edge that feels effortlessly cool. She carries a British-soul touch that’s smooth, smoky, and unhurried, delivered with an easy, down-to-earth energy.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fcameron-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Spoken Word", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 57,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
